import React from 'react';
import PropTypes from 'prop-types';
import { smartActionTypes } from 'utils/app-configs';
import { useParams } from 'react-router';
// eslint-disable-next-line max-len
import SmartActionSidepanelContainer from '../../containers/smart-action-sidepanel/smart-action-sidepanel-container';
// eslint-disable-next-line max-len
import FollowUpSidepanelContainer from '../../containers/smart-action-sidepanel/follow-up-sidepanel-container';

const ActionSidepanel = ({
    assignOrderToSmartAction,
    context,
    ticket,
    origin = 'ticket',
    openTicket,
}) => {
    const params = useParams();
    if (params.actionTypeId === smartActionTypes.customerDown) {
        return <FollowUpSidepanelContainer />;
    }
    return <SmartActionSidepanelContainer
      assignOrderToSmartAction={assignOrderToSmartAction}
      id={ticket?.sourceObjectId}
      context={context}
      origin={origin}
      openTicket={openTicket}
    />;
};

ActionSidepanel.propTypes = {
    assignOrderToSmartAction: PropTypes.func,
    context: PropTypes.object,
    ticket: PropTypes.object,
    origin: PropTypes.string,
    openTicket: PropTypes.func,
};

export default ActionSidepanel;
